import { configureStore } from '@reduxjs/toolkit';
import apiSlice from './actions/apiSlice';
import dashboardTitle from './actions/dashboardTitle';
import userTypeSlice from './actions/userTypeSlice';
import setRoleStore from './actions/setRoleStore';
import GetHeaderRolesSlice from './actions/GetHeaderRolesSlice';
import SupplierDropdownListSlice from './actions/SupplierDropdownListSlice';
import SupplierDropdownFilterSlice from './actions/SupplierDropdownFilterSlice'
import PostInviteSupplierListSlice from './actions/PostInviteSupplierListSlice';
import GetAdminSupplierUserListSlice from './actions/GetAdminSupplierUserListSlice';
import DeleteAdminSupplierSlice from './actions/DeleteAdminSupplierSlice';
import GetEmailDomainSupplierListSlice from './actions/GetEmailDomainSupplierListSlice';
import SupplierForecastTableDataReducer from './actions/SupplierForecastTableDataSlice';
import SupplierForecastSearchTableReducer from './actions/SupplierForecastSearchTableSlice';
import PUTEditInviteUserSlice from './actions/PUTEditInviteUserSlice';
import ForecastHistoryTableReducer from './actions/ForecastHistoryTableSlice';
import SupplierForecastSaveDataReducer from './actions/SupplierForecastSaveDataSlice';
import PostHideColumnsSlice from './actions/PostHideColumnsSlice';
import GetHideColumnsListSlice from './actions/GetHideColumnsListSlice';
import FileUploadSlice from './actions/FileUploadSlice';
import getforecastEmailSlice from './actions/forecastEmailSlice';
import getReasonCodeSlice  from './actions/getReasonCodeSlice';
import deleteReasonCodeSlice from './actions/deleteReasonCodeSlice';
import putEditReasonCodeSlice from './actions/putEditReasonCodeSlice';
import postReasonCodeSlice from './actions/postReasonCodeSlice';
import getBuyerDropdownFilter from './actions/BuyerDropdownFilterSlice';
import getBuyerForecastTableData from './actions/getBuyerForecastTableData';
import getBuyerForecastSearchTable from './actions/BuyerForecastSearchTableSlice';
import getBuyerForecastSaveDataSlice from './actions/BuyerForecastSaveDataSlice';
import submitBuyerForecastOverrideDataSlice from './actions/submitBuyerForecastOverrideDataSlice';
import getPOExceptionMgmtBuyerTable from './actions/getPOExceptionMgmtBuyerTable';
import getMaterialBatchData from './actions/getMaterialBatchDataSlice';
import setRegionPlantStore from './actions/setRegionPlantStore';
import getPlantsRegionSlice from './actions/getPlantsRegionSlice';
import getSupplierEmailsSlice from './actions/getSupplierEmailsSlice';
import addToSupplierEmailsSlice from './actions/addToSupplierEmailsSlice';
import sendMailToSupplierSlice from './actions/sendMailToSupplierSlice';
import sendToSupplierSlice from './actions/sendToSupplierSlice';
import getSupplierPortalDataSlice from './actions/getSupplierPortalDataSlice';
import updateUserResponseSlice from './actions/updateUserResponseSlice';
import updateCollabStatusSlice from './actions/updateCollabStatusSlice';
import PowerBIActionDashboardSlice from './actions/PowerBIActionDashboardSlice';
import getPOExceptionMgmtBuyerFilter from './actions/getPOExceptionMgmtBuyerFilter';
import getViewParticularAnnouncementSlice from './actions/GetViewParticularAnnouncementSlice';
import getViewAllAnnouncementSlice from './actions/GetViewAllAnnouncementSlice';
import getAllSupplierAnnouncementSlice from './actions/GetAllSupplierAnnouncementSlice';
import postAnnouncementSlice from './actions/postAnnouncementSlice';
import getUnreadCountAnnouncementsSlice from './actions/getUnreadCount AnnouncementsSlice';
import postreadCountAnnouncementsSlice from './actions/postreadCountAnnouncementsSlice';
import addAppAdminTrainingTopicSlice from './actions/addAppAdminTrainingTopicSlice';
import updateAppAdminTrainingTopicSlice from './actions/updateAppAdminTrainingTopicSlice';
import deleteAppAdminTrainingTopicSlice from './actions/deleteAppAdminTrainingTopicSlice';
import getAppAdminTrainingTopicSlice from './actions/getAppAdminTrainingTopicSlice';

export const store = configureStore({
  reducer: {
    apiData: apiSlice,
    dashboardDetails: dashboardTitle,
    setRoleStore: setRoleStore,
    userCardType: userTypeSlice,
    GetHeaderRolesSlice: GetHeaderRolesSlice,
    SupplierDropdownListSlice: SupplierDropdownListSlice,
    SupplierDropdownFilterSlice: SupplierDropdownFilterSlice,
    PostInviteSupplierListSlice: PostInviteSupplierListSlice,
    GetAdminSupplierUserListSlice: GetAdminSupplierUserListSlice,
    DeleteAdminSupplierSlice: DeleteAdminSupplierSlice,
    GetEmailDomainSupplierListSlice: GetEmailDomainSupplierListSlice,
    SupplierForecastTableDataSlice: SupplierForecastTableDataReducer,
    SupplierForecastSearchTableSlice: SupplierForecastSearchTableReducer,
    ForecastHistoryTableSlice: ForecastHistoryTableReducer,
    PUTEditInviteUserSlice: PUTEditInviteUserSlice,
    SupplierForecastSaveDataSlice: SupplierForecastSaveDataReducer,
    PostHideColumnsSlice: PostHideColumnsSlice,
    GetHideColumnsListSlice:GetHideColumnsListSlice,
    FileUploadSlice:FileUploadSlice,
    getforecastEmailSlice:getforecastEmailSlice,
    getReasonCodeSlice:getReasonCodeSlice,
    putEditReasonCodeSlice:putEditReasonCodeSlice,
    postReasonCodeSlice:postReasonCodeSlice,
    deleteReasonCodeSlice:deleteReasonCodeSlice,
    getBuyerDropdownFilter:getBuyerDropdownFilter,
    getBuyerForecastTableData:getBuyerForecastTableData,
    getBuyerForecastSearchTable:getBuyerForecastSearchTable,
    getBuyerForecastSaveDataSlice: getBuyerForecastSaveDataSlice,
    submitBuyerForecastOverrideDataSlice: submitBuyerForecastOverrideDataSlice,
    getPOExceptionMgmtBuyerTable: getPOExceptionMgmtBuyerTable,
    getMaterialBatchData: getMaterialBatchData,
    setRegionPlantStore: setRegionPlantStore,
    getPlantRegionSlice: getPlantsRegionSlice,
    getSupplierEmails: getSupplierEmailsSlice,
    addToSupplierEmails: addToSupplierEmailsSlice,
    sendMailToSupplier: sendMailToSupplierSlice,
    sendToSupplier: sendToSupplierSlice,
    getSupplierPortalData: getSupplierPortalDataSlice,
    updateUserResponse: updateUserResponseSlice,
    updateCollabStatus: updateCollabStatusSlice,
    PowerBIActionDashboardSlice: PowerBIActionDashboardSlice,
    getPOExceptionMgmtBuyerFilter: getPOExceptionMgmtBuyerFilter,
    getViewParticularAnnouncementSlice: getViewParticularAnnouncementSlice,
    getViewAllAnnouncementSlice: getViewAllAnnouncementSlice,
    getAllSupplierAnnouncementSlice: getAllSupplierAnnouncementSlice,
    postAnnouncementSlice: postAnnouncementSlice,
    getUnreadCountAnnouncementsSlice: getUnreadCountAnnouncementsSlice,
    postreadCountAnnouncementsSlice: postreadCountAnnouncementsSlice,
    addAppAdminTrainingTopicSlice: addAppAdminTrainingTopicSlice,
    updateAppAdminTrainingTopicSlice: updateAppAdminTrainingTopicSlice,
    deleteAppAdminTrainingTopicSlice: deleteAppAdminTrainingTopicSlice,
    getAppAdminTrainingTopicSlice: getAppAdminTrainingTopicSlice
  },

})